import React, { useContext, useEffect, useState } from 'react'
import styles from "./timePicker.module.css"
import InfoBox from './infoBox';
import { GetSchedule } from '../../../../utils/shedule';
import { notify } from '../../../toast';

const TimePicker = (props) => {

    const [isLoading, setIsLoading] = useState(true);
    const [TimeArray, setTimeArray] = useState([]) 
    
    useEffect(()=> {
        const fetchTimes = async() => {

            try {
                setTimeArray([])
                const request = await GetSchedule(props.selectedDate)

                if(request.data && request.status){
                    setTimeArray(request.data)
                    setIsLoading(false)
                }
                // console.log("kazkas: ",request.data)
                
            } catch (error) {
                notify(error.message,"error")
            }

        }

        fetchTimes();
    },[])

    const updatingTimesArrayHandler = (updatedArray) => {
        setTimeArray(updatedArray)
        props.onSelect(null)
    }

    const onTimeClickHandler = (time_obj) => {
        props.onSelect(time_obj.time)

    }

    return (

        <div className={styles.container}>
            <h2 className={styles.header}>Galimi rezervacijos laikai</h2>
            <div className={styles.time_grid}>
                {   
                    TimeArray &&
                    TimeArray.map(obj => {
                        if(obj.schedule_date === props.selectedDate){
                            return obj.schedule_hours.map((time_obj,index) => {
                                const isSelected = props.selectedTime === time_obj.time && time_obj.is_available
                                return <div 
                                    onClick={()=>{onTimeClickHandler(time_obj)}}
                                    key={index} 
                                    className={`${styles.time_box} ${!time_obj.is_available && styles.taken_box} ${isSelected && styles.selected}`}>
                                    <h3>{time_obj.time}</h3>
                                </div>
                            })
                        }
                        return null
                    })
                }
            </div>
            <InfoBox onRefresh={updatingTimesArrayHandler} isLoading={isLoading} TimeArray={TimeArray} {...props}/>
        </div>

    )
}

export default TimePicker